import { Injectable } from '@angular/core';
import {
  Router,
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { CoreService } from '../services/core.service';
import { PageNumber, PageSize } from '../shared/variables/variables';

@Injectable({
  providedIn: 'root',
})
export class IssuedCertificateResolver implements Resolve<boolean> {
  constructor(private coreService: CoreService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<any> {
    return this.coreService.getRequest(
      `IssuedCertificate?PageNumber=${PageNumber}&PageSize=${PageSize}`,
      { observe: 'response', responseType: 'json' },
    );
  }
}
